import { z } from 'zod';
import { parseWebApiResponse, webApiBooleanSchema } from './common';
const booleanFlagSchema = z.preprocess((value) => value ?? false, webApiBooleanSchema);
const accountSummarySchema = z
    .object({
    id: z.coerce.number().nullable().optional(),
    name: z.string().nullable().optional(),
})
    .strip()
    .nullable();
const portfolioSummarySchema = z
    .object({
    id: z.coerce.number().optional(),
    portfolioId: z.coerce.number().optional(),
    name: z.string().nullable().optional(),
    locations: z.preprocess((value) => value ?? [], z.array(z.unknown())).optional(),
    residentAdvocateFirstName: z.string().nullable().optional(),
})
    .passthrough();
const userRolesSchema = z.union([
    z
        .object({
        isLeasing: booleanFlagSchema.optional(),
        isManagement: booleanFlagSchema.optional(),
    })
        .strip(),
    z.array(z.string()),
]);
const defaultAuthenticatedPathSchema = z.enum(['/tasks', '/insights', '/text/conversations']);
export const currentUserResponseSchema = z
    .object({
    id: z.coerce.number(),
    uuid: z.string().nullable().optional(),
    firstName: z.string().nullable().optional(),
    lastName: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    accountId: z.coerce.number().nullable().optional(),
    account: accountSummarySchema.optional(),
    accountName: z.string().nullable().optional(),
    isDemoUser: booleanFlagSchema,
    isInternal: booleanFlagSchema,
    isAdmin: booleanFlagSchema,
    isGhostUser: booleanFlagSchema,
    isDataOnlyUser: booleanFlagSchema,
    isTasksOnlyUser: booleanFlagSchema,
    isReadOnlyUser: booleanFlagSchema,
    isUserAdmin: booleanFlagSchema,
    canAccessAnnouncementCenter: booleanFlagSchema,
    defaultToTasks: booleanFlagSchema,
    isResidentEngagementUser: booleanFlagSchema.optional(),
    isAutomatedSurveyUser: booleanFlagSchema.optional(),
    managesMultipleCommunities: booleanFlagSchema.optional(),
    defaultAuthenticatedPath: defaultAuthenticatedPathSchema.optional(),
    needsHoaAssistant: booleanFlagSchema.optional(),
    portfolios: z.array(portfolioSummarySchema).optional().default([]),
    roles: userRolesSchema.nullable().optional(),
    portfolioCustomizations: z.record(z.string(), z.unknown()).optional(),
})
    .strip();
export function parseCurrentUserResponse(data) {
    return parseWebApiResponse(currentUserResponseSchema, data, 'GET /api/user');
}
